// extracted by mini-css-extract-plugin
export default {"card":"Card_card__MhcZF","white":"Card_white__SvJ6M","details":"Card_details__cX-2x","ctas":"Card_ctas__7O+pK","image":"Card_image__stdqh"};